/**
 * MUSKLE Product Info / MILO — Product Milo client.
 *
 * Product Milo client.
 * Central route: window.MuskleMilo.ask → Render /milo/ask
 * for the current product handle. Composer activates on any valid PDP.
 */
(function () {
  const DIALOG_ID = 'muskle-product-info-chat';
  const CONTEXT_ID = 'mpic-drawer-product-context';
  const THREAD_ID = 'mpic-chat-thread';
  const INPUT_ID = 'mpic-popup-input';
  const SEND_ID = 'mpic-popup-send';
  const COMPOSER_ID = 'mpic-popup-composer';

  const dialogEl = document.getElementById(DIALOG_ID);
  const testMode = dialogEl && dialogEl.getAttribute('data-mpic-test-mode') === 'true';
  const mpicLocale = dialogEl && dialogEl.getAttribute('data-mpic-locale') === 'en' ? 'en' : 'nl';
  const indexUrl = (dialogEl && dialogEl.getAttribute('data-mpic-index-url')) || '';
  const answersUrl = (dialogEl && dialogEl.getAttribute('data-mpic-answers-url')) || '';

  const UI =
    mpicLocale === 'en'
      ? {
          fallback:
            'I cannot confirm this with certainty yet. Always check the label on the packaging or ask for advice in store.',
          noMatch:
            'I cannot find a reliable product match for this in the prepared MUSKLE data yet. Try creatine, whey, magnesium, omega 3, pre-workout or amino acids.',
          noMatchShort:
            'I cannot find a reliable product match for this in the prepared MUSKLE data yet.',
          generalSafety:
            'This is not medical advice. If you use medication, blood thinners, are pregnant, breastfeeding, have allergies or medical questions: always check the label and consult a doctor or pharmacist.',
          productSafetyHint: ' For this product you can also review warnings in the product guide.',
          selectProduct:
            'Select a product first via “Ask MILO” on a product page, or ask a general search question such as “Which creatine do you recommend?”',
          contextLabel: 'Your question is about this product',
          viewProduct: 'View product',
          readGuide: 'Read product guide',
          debugSummary: 'Internal test info',
          noGuarantee:
            'Milo does not guarantee muscle growth, fat loss, sleep, hormone or medical outcomes. This is product information only. Check the label and the product guide.',
          lockUnrelated:
            'This question is not about the selected product. Ask me a question about this product.',
          lockUnverified:
            'I cannot verify this from the available product information for the selected product.',
          temporarilyUnavailable:
            'Milo is temporarily unavailable. Please try again in a moment.',
          working: 'Milo is looking this up…',
        }
      : {
          fallback:
            'Ik kan dit nog niet met zekerheid bevestigen. Controleer altijd het etiket op de verpakking of vraag advies in de winkel.',
          noMatch:
            'Ik vind hiervoor nog geen betrouwbare productmatch in de voorbereide MUSKLE data. Probeer bijvoorbeeld: creatine, whey, magnesium, omega 3, pre-workout of aminozuren.',
          noMatchShort:
            'Ik vind hiervoor nog geen betrouwbare productmatch in de voorbereide MUSKLE data.',
          generalSafety:
            'Dit is geen medisch advies. Bij medicijngebruik, bloedverdunners, zwangerschap, borstvoeding, allergieën of medische vragen: controleer altijd het etiket en overleg met een arts of apotheker.',
          productSafetyHint: ' Voor dit product kun je ook de waarschuwingen in de Productgids bekijken.',
          selectProduct:
            'Selecteer eerst een product via “Stel vraag aan MILO” op een productpagina, of stel een algemene zoekvraag zoals “Welke creatine raad je aan?”',
          contextLabel: 'Je vraagt over dit product',
          viewProduct: 'Bekijk product',
          readGuide: 'Lees Productgids',
          debugSummary: 'Interne testinfo',
          noGuarantee:
            'Milo geeft geen garanties over spiergroei, vetverlies, slaap, hormonen of genezing. Dit is alleen productinformatie. Controleer het etiket en de Productgids.',
          lockUnrelated:
            'Deze vraag gaat niet over het geselecteerde product. Stel mij een vraag over dit product.',
          lockUnverified:
            'Deze informatie kan ik niet verifiëren uit de beschikbare productinformatie van het geselecteerde product.',
          temporarilyUnavailable: 'Milo is even niet beschikbaar. Probeer het zo meteen opnieuw.',
          working: 'Milo zoekt dit op…',
        };

  const FALLBACK = UI.fallback;
  const NO_MATCH = UI.noMatch;
  const NO_MATCH_SHORT = UI.noMatchShort;
  const GENERAL_SAFETY_REPLY = UI.generalSafety;
  const PRODUCT_SAFETY_HINT = UI.productSafetyHint;
  const SELECT_PRODUCT_MSG = UI.selectProduct;

  const INTENT_ORDER = ['safety', 'ingredients', 'productgids', 'nutrition', 'usage', 'recommendation'];

  const INTENT_PATTERNS = {
    usage: /gebruik|nemen|dosering|wanneer|hoe gebruik|\bdit\b|how do i use|how to use|dosage|when to take|\bthis\b/i,
    ingredients: /ingredi[ëe]nten|ingredienten|wat zit erin|samenstelling|what'?s in it|what is in it|ingredients|composition|\bbevat\b|allergenen|allergens|allergen|what does it contain|extract|withanol/i,
    nutrition: /voedingswaarde|eiwit|kcal|calorie|suiker|koolhydraten|vetten?|vet\b|nutrition facts|protein|calories|carbs|fat\b/i,
    safety: /waarschuwing|warnings?|veilig|medicatie|medicijn|medication|zwanger|zwangerschap|pregnant|pregnancy|borstvoeding|breastfeeding|allergie|allergy|ziekte|bijwerking|bloedverdunner|warfarine|geneest|genezen|behandel|kan ik dit nemen|mag ik dit nemen|can i take|safe to take/i,
    productgids: /productgids|product guide|product guides|uitleg|lees meer|meer lezen|where can i read|read more|\bgids\b/i,
    recommendation: /welke|zoek|beste|past bij mij|aanrader|voor mij|alternatief|\braad\b|raad je aan|recommend|which|looking for|search for|ik zoek|find a product/i,
  };

  const CHIP_QUESTIONS = {
    Gebruik: 'Hoe gebruik ik dit?',
    'Ingrediënten': 'Wat zit erin?',
    Voedingswaarden: 'Hoeveel eiwit of kcal zit erin?',
    Waarschuwingen: 'Zijn er waarschuwingen?',
    Productgids: 'Waar is de productgids?',
    'Zoek een product': 'Welke creatine raad je aan?',
    Use: 'How do I use this?',
    Ingredients: "What's in it?",
    'Nutrition facts': 'How much protein or calories are in it?',
    Warnings: 'Are there any warnings?',
    'Product guides': 'Where is the product guide?',
    'Find a product': 'Which creatine do you recommend?',
  };

  let productIndex = null;
  let answersBundle = null;
  let loadPromise = null;
  let currentHandle = '';
  let currentTitle = '';
  let productgidsFacts = null;
  let asking = false;
  let pendingRow = null;
  let conversationId = '';
  let conversationHistory = [];
  let conversationHandle = '';

  const PRODUCT_LOCK_TEST_HANDLE = 'fast-forward-nutrition-creatine-creapure';
  const MILO_ASK_URL = 'https://muskle-milo-service.onrender.com/milo/ask';
  const HISTORY_MAX_TURNS = 8;
  const HISTORY_MAX_CHARS = 400;

  function unpublishedThemeId() {
    try {
      const theme = window.Shopify && Shopify.theme;
      return theme && theme.id != null ? String(theme.id) : '';
    } catch (e) {
      return '';
    }
  }

  function isCentralProductAiRoute() {
    // Productgids AIO and PDP both bind a handle via setProductContext / data-mpic-handle.
    // Do not require the popup dialog: AIO uses the same ask() without opening it.
    return !!currentHandle;
  }

  function clipHistoryText(text) {
    const value = normalize(text);
    if (value.length <= HISTORY_MAX_CHARS) return value;
    return value.slice(0, HISTORY_MAX_CHARS);
  }

  function newConversationId() {
    if (window.crypto && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function resetConversation() {
    conversationId = '';
    conversationHistory = [];
    conversationHandle = '';
  }

  function ensureConversation(handle) {
    if (conversationHandle !== handle) {
      resetConversation();
      conversationHandle = handle;
    }
    if (!conversationId) conversationId = newConversationId();
    return conversationId;
  }

  function rememberTurn(role, text, mentionedHandles) {
    const turn = { role: role, text: clipHistoryText(text) };
    if (mentionedHandles && mentionedHandles.length) {
      turn.mentionedHandles = mentionedHandles.slice(0, 8);
    }
    conversationHistory.push(turn);
    if (conversationHistory.length > HISTORY_MAX_TURNS) {
      conversationHistory = conversationHistory.slice(-HISTORY_MAX_TURNS);
    }
  }

  function isCentralMainAiRoute() {
    return !!dialogEl && !currentHandle;
  }

  function formatEuro(amount) {
    const n = Number(amount);
    if (!Number.isFinite(n)) return String(amount);
    return n.toFixed(2).replace('.', ',');
  }

  function cardsFromRender(cards) {
    return (cards || []).map(function (card) {
      let summary = card.reason || '';
      if (card.priceMin != null) {
        const same = card.price != null || card.priceMin === card.priceMax;
        const price = same
          ? '€' + formatEuro(card.price != null ? card.price : card.priceMin)
          : '€' + formatEuro(card.priceMin) + ' – €' + formatEuro(card.priceMax);
        const avail =
          card.available === true ? (mpicLocale === 'en' ? 'Available' : 'Beschikbaar') : '';
        summary = [price, avail].filter(Boolean).join(' · ');
      }
      return {
        title: card.title,
        vendor: card.vendor,
        image_url: card.imageUrl,
        product_url: card.productUrl,
        guide_url: card.guideUrl,
        guide_available: !!card.guideUrl,
        short_summary: summary,
        handle: card.handle,
      };
    });
  }

  function isProductLockActive() {
    return currentHandle === PRODUCT_LOCK_TEST_HANDLE;
  }

  function isLockProductQuestion(question) {
    const q = String(question || '');
    return /prote[iï]ne|\beiwitten?\b|\beiwit\b|suiker|sugars?|kcal|calorie|voedingswaarde|nutrition facts|ingredi|samenstelling|wat zit erin|allergeen|allergens?|dosering|dagelijks|hoeveel moet ik|hoe gebruik|zit er|bevat |gebruik|waarschuw|warnings?|directions|ingredients?/i.test(
      q
    );
  }

  function isLockRelatedQuestion(question) {
    const q = String(question || '');
    if (isIdentityQuestion(q)) return true;
    if (/\bcreapure\b|creatine creapure/i.test(q)) return true;
    if (/\bdit\b|\bdeze\b|\bthis\b/i.test(q)) return true;
    if (isLockProductQuestion(q) && !(isRecommendationQuestion(q) && !/\bdit\b|\bdeze\b|\bthis\b|creapure/i.test(q))) {
      return true;
    }
    const found = detectIntents(q);
    if (found.includes('recommendation') && !/\bdit\b|\bthis\b|creapure/i.test(q)) return false;
    if (found.includes('usage') || found.includes('ingredients') || found.includes('nutrition') || found.includes('productgids')) {
      return true;
    }
    if (found.includes('safety') && /\bdit\b|\bthis\b|creapure/i.test(q)) return true;
    if (isRecommendationQuestion(q) || isCatalogSearchQuestion(q)) return false;
    return false;
  }

  function normalize(str) {
    return String(str || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function findProductInIndex(handle, title) {
    if (!productIndex || !productIndex.products) return null;
    const h = normalize(handle);
    if (h) {
      const byHandle = productIndex.products.find(function (p) {
        return p.handle === h;
      });
      if (byHandle) return byHandle;
    }
    const t = normalize(title).toLowerCase();
    if (!t) return null;
    const exact = productIndex.products.find(function (p) {
      return normalize(p.title).toLowerCase() === t;
    });
    if (exact) return exact;
    const partial = productIndex.products.find(function (p) {
      const pt = normalize(p.title).toLowerCase();
      return pt.includes(t) || t.includes(pt);
    });
    return partial || null;
  }

  function mergeProductContext(trigger, indexProduct) {
    const index = indexProduct || {};
    const handle = normalize(trigger.handle) || normalize(index.handle) || '';
    const title = normalize(trigger.product) || normalize(index.title) || '';
    const vendor = normalize(trigger.vendor) || normalize(index.vendor) || '';
    const imageUrl = normalize(trigger.image) || normalize(index.image_url) || '';
    const productUrl = normalize(trigger.productUrl) ||
      (mpicLocale === 'en' && index.product_url_en ? index.product_url_en : index.product_url) ||
      '';
    const guideUrl = normalize(trigger.guideUrl) ||
      (mpicLocale === 'en' && index.guide_url_en ? index.guide_url_en : index.guide_url) ||
      '';
    const guideAvailable = index.guide_available === true || !!normalize(trigger.guideUrl);

    return {
      handle: handle,
      title: title,
      vendor: vendor,
      imageUrl: imageUrl,
      productUrl: productUrl,
      guideUrl: guideUrl,
      guideAvailable: guideAvailable,
    };
  }

  function clearProductContext() {
    currentHandle = '';
    currentTitle = '';
    resetConversation();
    const wrap = document.getElementById(CONTEXT_ID);
    if (!wrap) return;
    wrap.hidden = true;
    wrap.innerHTML = '';
  }

  function renderProductHeroCard(ctx) {
    const wrap = document.getElementById(CONTEXT_ID);
    if (!wrap || !ctx || !ctx.title) {
      clearProductContext();
      return;
    }

    currentHandle = ctx.handle || currentHandle;
    currentTitle = ctx.title;

    const imageHtml = ctx.imageUrl
      ? '<div class="mpic-product-context-image">' +
        '<img src="' +
        escapeHtml(ctx.imageUrl) +
        '" alt="" width="72" height="72" loading="lazy" decoding="async">' +
        '</div>'
      : '';

    const vendorHtml = ctx.vendor
      ? '<p class="mpic-product-context-vendor">' + escapeHtml(ctx.vendor) + '</p>'
      : '';

    const productBtn = ctx.productUrl
      ? '<a class="mpic-product-context-btn mpic-product-context-btn--product" href="' +
        escapeHtml(ctx.productUrl) +
        '">' +
        escapeHtml(UI.viewProduct) +
        '</a>'
      : '';

    const guideBtn =
      ctx.guideAvailable && ctx.guideUrl
        ? '<a class="mpic-product-context-btn mpic-product-context-btn--guide" href="' +
          escapeHtml(ctx.guideUrl) +
          '">' +
          escapeHtml(UI.readGuide) +
          '</a>'
        : '';

    wrap.hidden = false;
    wrap.innerHTML =
      '<div class="mpic-product-context-card__inner">' +
      imageHtml +
      '<div class="mpic-product-context-meta">' +
      '<p class="mpic-product-context-label">' +
      escapeHtml(UI.contextLabel) +
      '</p>' +
      vendorHtml +
      '<p class="mpic-product-context-title">' +
      escapeHtml(ctx.title) +
      '</p>' +
      '<div class="mpic-product-context-actions">' +
      productBtn +
      guideBtn +
      '</div></div></div>';
  }

  function applyProductContext(trigger) {
  const hasTrigger = !!(normalize(trigger.product) || normalize(trigger.handle));
  if (!hasTrigger) {
    // Attempt to derive product handle from the current PDP URL or reuse existing handle.
    let derived = '';
    try {
      const p = String(location.pathname || '');
      const parts = p.split('/');
      if (parts.length >= 3 && parts[1] === 'products') {
        derived = (parts[2] || '').split(/[\/?#]/)[0];
      }
    } catch (e) {}
    if (!derived && currentHandle) derived = currentHandle;
    if (!derived) {
      clearProductContext();
      return Promise.resolve();
    }
    trigger = trigger || {};
    trigger.handle = derived;
  }

    const nextHandle = normalize(trigger.handle || '');
    if (nextHandle && nextHandle !== currentHandle) resetConversation();

    function finish(indexProduct) {
      renderProductHeroCard(mergeProductContext(trigger, indexProduct));
    }

    if (testMode && indexUrl) {
      return loadMiloData().then(function () {
        finish(findProductInIndex(trigger.handle, trigger.product));
      });
    }

    finish(null);
    return Promise.resolve();
  }

  function readTriggerContext(trigger) {
    const product = trigger.getAttribute('data-mpic-product') || '';
    let handle = trigger.getAttribute('data-mpic-handle') || '';
    const image = trigger.getAttribute('data-mpic-image') || '';
    const vendor = trigger.getAttribute('data-mpic-vendor') || '';
    let productUrl = trigger.getAttribute('data-mpic-product-url') || '';
    let guideUrl = trigger.getAttribute('data-mpic-guide-url') || '';

    // Fallback: if the trigger does not include a handle (typical on PDP),
    // derive the current product handle from the page URL (/products/:handle).
    if (!handle) {
      try {
        const p = String(location.pathname || '');
        const parts = p.split('/');
        if (parts.length >= 3 && parts[1] === 'products') {
          handle = (parts[2] || '').split(/[\/?#]/)[0];
        } else {
          handle = '';
        }
      } catch (e) {
        handle = '';
      }
    }

    // If productUrl is empty but we have a handle, create a default product URL.
    if (!productUrl && handle) {
      productUrl = `/products/${handle}`;
    }

    return {
      product,
      handle,
      image,
      vendor,
      productUrl,
      guideUrl,
    };
  }

  function setProductContext(title, handle) {
    applyProductContext({ product: title, handle: handle });
  }

  function resolveHandleFromTitle(title) {
    if (!productIndex || !title) return '';
    const t = normalize(title).toLowerCase();
    const exact = productIndex.products.find(function (p) {
      return normalize(p.title).toLowerCase() === t;
    });
    if (exact) return exact.handle;
    const partial = productIndex.products.find(function (p) {
      const pt = normalize(p.title).toLowerCase();
      return pt.includes(t) || t.includes(pt);
    });
    return partial ? partial.handle : '';
  }

  function resolveHandleFromQuestion(question) {
    if (!productIndex) return '';
    const q = question.toLowerCase();
    let best = { handle: '', score: 0 };
    productIndex.products.forEach(function (p) {
      const title = normalize(p.title).toLowerCase();
      if (!title || title.length < 4) return;
      if (q.includes(title)) {
        const score = title.length + (p.answer_ready ? 50 : 0);
        if (score > best.score) best = { handle: p.handle, score: score };
      }
    });
    return best.handle;
  }

  function detectIntents(question) {
    const found = [];
    Object.keys(INTENT_PATTERNS).forEach(function (key) {
      if (INTENT_PATTERNS[key].test(question)) found.push(key);
    });
    return found;
  }

  function isRecommendationQuestion(question) {
    return INTENT_PATTERNS.recommendation.test(question);
  }

  function isMedicalQuestion(question) {
    return /geneest|genezen|behandel|ziekte|diabetes|kanker|diagnose|bloedverdunner|warfarine|zwanger|pregnant|pregnancy|\bcure\b|treat my|disease|cancer|diagnos|joint pain|klachten/i.test(
      question
    );
  }

  function isOutcomeClaimQuestion(question) {
    const q = String(question || '');
    if (/gegarandeerd|garandeert|garantie|guaranteed|\bguarantee\b/i.test(q)) return true;
    if (/will this (cure|make|guarantee)|geneest dit|will this make me/i.test(q)) return true;
    return false;
  }

  function isIdentityQuestion(question) {
    return /wat is (dit|het) product|what is this product|tell me about this product|waar is dit product voor|what does this product/i.test(
      question
    );
  }

  function isGeneralSafetyQuestion(question) {
    return /medicatie|medicijn|medication|bloedverdunner|warfarine|zwanger|zwangerschap|pregnant|pregnancy|borstvoeding|breastfeeding|ziekte|bijwerking|safe to take|can i take|kan ik dit nemen|mag ik dit nemen|is this safe|is dit veilig|safe with|veilig met/i.test(
      question
    );
  }

  function isCatalogSearchQuestion(question) {
    if (isGeneralSafetyQuestion(question) || isMedicalQuestion(question)) return false;
    if (/hoe gebruik|wat zit erin|ingredi|eiwit|kcal|voedingswaarde|\bdit\b|how do i use|what ingredients|how much protein/i.test(question)) {
      return false;
    }
    if (isRecommendationQuestion(question)) return true;
    if (typeof MiloSearchEngine === 'undefined') return false;
    if (MiloSearchEngine.isSafetyQuery && MiloSearchEngine.isSafetyQuery(question)) return false;
    const anchor = MiloSearchEngine.detectCategoryAnchor(question);
    if (anchor.confidence !== 'none') return true;
    const q = MiloSearchEngine.extractSearchQuery(question);
    return q.length >= 4;
  }

  function needsProductContext(question, intent) {
    if (isGeneralSafetyQuestion(question) || isRecommendationQuestion(question) || isCatalogSearchQuestion(question)) {
      return false;
    }
    if (intent === 'recommendation' || intent === 'safety') return false;
    return /how do i use|what'?s in it|what is in it|ingredients|nutrition facts|protein|calories|product guide|product guides|\bthis\b|how do i use|wat zit erin|ingredi|eiwit|kcal|voedingswaarde|\bdit\b/i.test(
      question
    );
  }

  function pickIntent(question) {
    if (isIdentityQuestion(question)) return 'identity';
    const knownProduct = currentHandle || resolveHandleFromQuestion(question) || uniqueSearchHandle(question);
    if ((isRecommendationQuestion(question) || isCatalogSearchQuestion(question)) && !knownProduct) {
      return 'recommendation';
    }
    if (isGeneralSafetyQuestion(question) || isMedicalQuestion(question) || isOutcomeClaimQuestion(question)) {
      return 'safety';
    }

    const found = detectIntents(question);
    const productScoped = !!knownProduct && !isRecommendationQuestion(question);

    for (let i = 0; i < INTENT_ORDER.length; i += 1) {
      const intent = INTENT_ORDER[i];
      if (intent === 'recommendation' && productScoped) continue;
      if (found.includes(intent)) return intent;
    }

    if (knownProduct) return 'usage';
    if (isRecommendationQuestion(question)) return 'recommendation';
    return 'usage';
  }

  function buildSafetyResponse(handle, intent) {
    let text = GENERAL_SAFETY_REPLY;
    if (handle) text += PRODUCT_SAFETY_HINT;
    return {
      text: text,
      cards: [],
      debug: { intent: intent || 'safety', handle: handle || '', verifiedIngredients: false, verifiedNutrition: false },
    };
  }

  function buildClaimRefusal(handle, intent) {
    let text = GENERAL_SAFETY_REPLY + ' ' + UI.noGuarantee;
    if (handle) text += PRODUCT_SAFETY_HINT;
    return {
      text: text,
      cards: [],
      debug: { intent: intent || 'safety', handle: handle || '', verifiedIngredients: false, verifiedNutrition: false },
    };
  }

  function buildRecommendationResponse(question, intent) {
    if (!productIndex || !productIndex.products || typeof MiloSearchEngine === 'undefined') {
      return {
        text: NO_MATCH,
        cards: [],
        debug: { intent: intent || 'recommendation', handle: '', verifiedIngredients: false, verifiedNutrition: false },
      };
    }

    const result = MiloSearchEngine.searchCatalog(question, productIndex.products);
    let message = result.message;
    if (mpicLocale === 'en') {
      if (result.status === 'none') message = UI.noMatch;
      else if (result.status === 'ambiguous') message = UI.noMatchShort + ' Please say which product you mean.';
      else message = 'These products from the prepared MUSKLE data may match your question:';
    }
    return {
      text: message,
      cards: result.products || [],
      debug: {
        intent: intent || 'recommendation',
        handle: '',
        searchStatus: result.status,
        searchAnchor: result.anchor ? result.anchor.id : '',
        searchScore: result.bestScore,
        verifiedIngredients: false,
        verifiedNutrition: false,
      },
    };
  }

  function loadMiloData() {
    if (loadPromise) return loadPromise;
    if (!indexUrl || !answersUrl) {
      loadPromise = Promise.resolve(false);
      return loadPromise;
    }
    loadPromise = Promise.all([
      fetch(indexUrl).then(function (r) {
        if (!r.ok) throw new Error('index fetch failed');
        return r.json();
      }),
      fetch(answersUrl).then(function (r) {
        if (!r.ok) throw new Error('answers fetch failed');
        return r.json();
      }),
    ])
      .then(function (results) {
        productIndex = results[0];
        answersBundle = results[1];
        return true;
      })
      .catch(function () {
        productIndex = null;
        answersBundle = null;
        return false;
      });
    return loadPromise;
  }

  function getAnswerForHandle(handle) {
    if (!answersBundle || !answersBundle.by_handle) return null;
    return answersBundle.by_handle[handle] || null;
  }

  function getIntentAnswer(answer, intent) {
    const fallback = mpicLocale === 'en' ? answer?.fallback_unverified_en || FALLBACK : answer?.fallback_unverified || FALLBACK;
    if (!answer || !answer.intents) return { text: fallback, ready: false, guideUrl: '' };
    const row = answer.intents.find(function (i) {
      return i.intent === intent;
    });
    if (!row) return { text: fallback, ready: false, guideUrl: '' };
    const text =
      mpicLocale === 'en' && row.short_answer_en ? row.short_answer_en : row.short_answer || fallback;
    const guideUrl =
      mpicLocale === 'en' && (row.guide_url_en || answer.guide_url_en)
        ? row.guide_url_en || answer.guide_url_en
        : row.guide_url || answer.guide_url || '';
    return {
      text: text,
      ready: row.ready === true,
      guideUrl: guideUrl,
      guideAnchor: row.guide_anchor || '',
    };
  }

  function lockProductName() {
    return currentTitle || '';
  }

  function lockPackNote() {
    return mpicLocale === 'en'
      ? ' Always check the label on the packaging you receive.'
      : ' Controleer altijd het etiket van de ontvangen verpakking.';
  }

  function findPgRow(rows, pattern) {
    if (!rows || !rows.length) return null;
    for (let i = 0; i < rows.length; i += 1) {
      const label = String((rows[i] && rows[i].label) || '');
      if (pattern.test(label)) return rows[i];
    }
    return null;
  }

  function pgDebug(intent, extras) {
    extras = extras || {};
    return {
      intent: intent,
      handle: PRODUCT_LOCK_TEST_HANDLE,
      productgids: true,
      verifiedIngredients: extras.verifiedIngredients === true,
      verifiedNutrition: extras.verifiedNutrition === true,
    };
  }

  function buildPgTextResponse(text, intent, extras) {
    return {
      text: text,
      cards: [],
      debug: pgDebug(intent, extras),
    };
  }

  function formatPgNutritionRow(row) {
    const label = String(row.label || '').trim();
    const serving = String(row.per_serving || '').trim();
    const per100 = String(row.per_100g || '').trim();
    if (mpicLocale === 'en') {
      let text = 'The Product Guide for ' + lockProductName() + ' lists ' + label + ': ' + serving + ' per serving';
      if (per100 && per100 !== '—' && per100 !== '-') text += ' (' + per100 + ' per 100 g)';
      text += '.';
      return text + lockPackNote();
    }
    let text = 'In de Productgids van ' + lockProductName() + ' staat bij ' + label + ': ' + serving + ' per portie';
    if (per100 && per100 !== '—' && per100 !== '-') text += ' (' + per100 + ' per 100 g)';
    text += '.';
    return text + lockPackNote();
  }

  function formatPgNutritionTable(facts) {
    const rows = (facts && facts.composition) || [];
    if (!rows.length) return '';
    const lines = rows
      .map(function (row) {
        const label = String(row.label || '').trim();
        const serving = String(row.per_serving || '').trim();
        if (!label || !serving) return '';
        const per100 = String(row.per_100g || '').trim();
        return per100 && per100 !== '—' && per100 !== '-'
          ? label + ': ' + serving + (mpicLocale === 'en' ? ' per serving / ' : ' per portie / ') + per100 + (mpicLocale === 'en' ? ' per 100 g' : ' per 100 g')
          : label + ': ' + serving + (mpicLocale === 'en' ? ' per serving' : ' per portie');
      })
      .filter(Boolean);
    if (!lines.length) return '';
    if (mpicLocale === 'en') {
      return (
        'The Product Guide for ' +
        lockProductName() +
        ' lists these typical values: ' +
        lines.join('; ') +
        '.' +
        lockPackNote()
      );
    }
    return (
      'In de Productgids van ' +
      lockProductName() +
      ' staan deze typische waarden: ' +
      lines.join('; ') +
      '.' +
      lockPackNote()
    );
  }

  function formatPgIngredientRow(row) {
    const label = String(row.label || '').trim();
    const value = String(row.value || '').trim();
    if (!value) return '';
    if (mpicLocale === 'en') {
      return 'The Product Guide for ' + lockProductName() + ' lists ' + label + ': ' + value + '.' + lockPackNote();
    }
    return 'In de Productgids van ' + lockProductName() + ' staat bij ' + label + ': ' + value + '.' + lockPackNote();
  }

  function buildProductgidsLockResponse(question, intent) {
    if (!isProductLockActive() || !productgidsFacts) return null;
    const q = String(question || '');
    const facts = productgidsFacts;
    const composition = facts.composition || [];
    const ingredients = facts.ingredients || [];

    if (intent === 'nutrition') {
      const specificSugar = /suiker|sugar/i.test(q);
      const specificProtein = /prote[iï]ne|\beiwitten?\b|\beiwit\b|protein/i.test(q);
      const specificEnergy = /kcal|calorie|energie|energy/i.test(q) && !/voedingswaarde|nutrition facts/i.test(q);
      let row = null;
      if (specificSugar) row = findPgRow(composition, /suiker|sugar/i);
      else if (specificProtein) row = findPgRow(composition, /eiwit|protein/i);
      else if (specificEnergy) row = findPgRow(composition, /energie|energy/i);
      if (row && String(row.per_serving || '').trim()) {
        return buildPgTextResponse(formatPgNutritionRow(row), 'nutrition', { verifiedNutrition: true });
      }
      if (specificSugar || specificProtein || specificEnergy) return null;
      const table = formatPgNutritionTable(facts);
      if (table) return buildPgTextResponse(table, 'nutrition', { verifiedNutrition: true });
      return null;
    }

    if (intent === 'ingredients') {
      if (/allergeen|allergen/i.test(q)) {
        const allergen = findPgRow(ingredients, /allergeen|allergen/i);
        if (allergen && String(allergen.value || '').trim()) {
          return buildPgTextResponse(formatPgIngredientRow(allergen), 'ingredients', { verifiedIngredients: true });
        }
        return null;
      }
      const ing = findPgRow(ingredients, /ingredi|ingredient/i) || ingredients[0];
      if (ing && String(ing.value || '').trim()) {
        return buildPgTextResponse(formatPgIngredientRow(ing), 'ingredients', { verifiedIngredients: true });
      }
      return null;
    }

    if (intent === 'usage' && String(facts.directions || '').trim()) {
      const directions = String(facts.directions || '')
        .replace(/\s*\n\s*/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      const text =
        mpicLocale === 'en'
          ? 'The Product Guide for ' + lockProductName() + ' lists these directions: ' + directions + lockPackNote()
          : 'In de Productgids van ' + lockProductName() + ' staat bij gebruik: ' + directions + lockPackNote();
      return buildPgTextResponse(text, 'usage', {});
    }

    if (intent === 'safety' && String(facts.warnings || '').trim()) {
      const warnings = String(facts.warnings || '')
        .replace(/\s*\n\s*/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      const text =
        mpicLocale === 'en'
          ? 'The Product Guide for ' + lockProductName() + ' lists these warnings: ' + warnings + lockPackNote()
          : 'In de Productgids van ' + lockProductName() + ' staan deze waarschuwingen: ' + warnings + lockPackNote();
      return buildPgTextResponse(text, 'safety', {});
    }

    return null;
  }

  function uniqueSearchHandle(question) {
    if (!productIndex || !productIndex.products || typeof MiloSearchEngine === 'undefined') return '';
    const result = MiloSearchEngine.searchCatalog(question, productIndex.products);
    if (result.status === 'ok' && result.products && result.products.length === 1) {
      return result.products[0].handle;
    }
    return '';
  }

  function resolveActiveHandle(question, intent) {
    if (currentHandle) return currentHandle;
    return resolveHandleFromQuestion(question) || uniqueSearchHandle(question);
  }

  function refreshProductgidsFactsFromDom() {
    if (productgidsFacts) return;
    const el = typeof document !== 'undefined' ? document.querySelector("[data-mpg-pg-source='muskle_pg']") : null;
    if (!el) return;
    try {
      const parsed = JSON.parse(String(el.textContent || '').replace(/^\s+|\s+$/g, ''));
      if (parsed && parsed.handle && parsed.handle === currentHandle) productgidsFacts = parsed;
    } catch (e) {}
  }

  function buildResponse(question) {
    const lockActive = isProductLockActive();
    if (lockActive) refreshProductgidsFactsFromDom();
    let intent = pickIntent(question);
    if (lockActive) {
      const q = String(question || '');
      if (/prote[iï]ne|\beiwit\b|suiker|kcal|calorie|voedingswaarde/i.test(q)) intent = 'nutrition';
      else if (/ingredi|samenstelling|wat zit erin|allergeen/i.test(q)) intent = 'ingredients';
      else if (/hoeveel moet ik|dagelijks|dosering|wanneer gebruik|hoe gebruik/i.test(q)) intent = 'usage';
    }
    const handle = lockActive ? PRODUCT_LOCK_TEST_HANDLE : resolveActiveHandle(question, intent);

    if (lockActive && !isLockRelatedQuestion(question)) {
      return {
        text: UI.lockUnrelated,
        cards: [],
        debug: {
          intent: 'lock_unrelated',
          handle: PRODUCT_LOCK_TEST_HANDLE,
          verifiedIngredients: false,
          verifiedNutrition: false,
        },
      };
    }

    if (isOutcomeClaimQuestion(question)) {
      return buildClaimRefusal(handle, intent);
    }
    if (isMedicalQuestion(question)) {
      return buildSafetyResponse(handle, intent);
    }

    if (isIdentityQuestion(question)) {
      if (!handle) {
        return {
          text: SELECT_PRODUCT_MSG,
          cards: [],
          debug: { intent: 'identity', handle: '', verifiedIngredients: false, verifiedNutrition: false },
        };
      }
      const identityProduct =
        productIndex &&
        productIndex.products.find(function (p) {
          return p.handle === handle;
        });
      const identityText =
        identityProduct && mpicLocale === 'en' && identityProduct.short_summary_en
          ? identityProduct.short_summary_en
          : (identityProduct && identityProduct.short_summary) || FALLBACK;
      return {
        text: identityText,
        cards: [],
        debug: { intent: 'identity', handle: handle, verifiedIngredients: false, verifiedNutrition: false },
      };
    }

    if (
      !lockActive &&
      (intent === 'recommendation' || ((isRecommendationQuestion(question) || isCatalogSearchQuestion(question)) && !handle))
    ) {
      return buildRecommendationResponse(question, intent);
    }

    if (isGeneralSafetyQuestion(question) || (intent === 'safety' && !handle)) {
      return buildSafetyResponse(handle, intent);
    }

    if (!handle) {
      if (needsProductContext(question, intent)) {
        return {
          text: SELECT_PRODUCT_MSG,
          cards: [],
          debug: { intent: intent, handle: '', verifiedIngredients: false, verifiedNutrition: false },
        };
      }
      if (intent === 'safety') {
        return buildSafetyResponse('', intent);
      }
      if (intent === 'productgids') {
        return {
          text: NO_MATCH,
          cards: [],
          debug: { intent: intent, handle: '', verifiedIngredients: false, verifiedNutrition: false },
        };
      }
      return {
        text: SELECT_PRODUCT_MSG,
        cards: [],
        debug: { intent: intent, handle: '', verifiedIngredients: false, verifiedNutrition: false },
      };
    }

    const answer = getAnswerForHandle(handle);
    const verifiedIngredients = !!(answer && answer.verified && answer.verified.ingredients);
    const verifiedNutrition = !!(answer && answer.verified && answer.verified.nutrition);

    const pgLockAnswer = lockActive ? buildProductgidsLockResponse(question, intent) : null;
    if (pgLockAnswer) return pgLockAnswer;

    if (!answer) {
      return {
        text: FALLBACK,
        cards: [],
        debug: { intent: intent, handle: handle, verifiedIngredients: false, verifiedNutrition: false },
      };
    }

    if (intent === 'safety' && (isGeneralSafetyQuestion(question) || isMedicalQuestion(question))) {
      return buildSafetyResponse(handle, intent);
    }

    const row = getIntentAnswer(answer, intent);
    if (lockActive && row.ready !== true) {
      return {
        text: UI.lockUnverified,
        cards: [],
        debug: {
          intent: intent,
          handle: handle,
          verifiedIngredients: verifiedIngredients,
          verifiedNutrition: verifiedNutrition,
        },
      };
    }

    const product =
      productIndex &&
      productIndex.products.find(function (p) {
        return p.handle === handle;
      });

    if (product) {
      if (mpicLocale === 'en' && product.guide_url_en) row.guideUrl = product.guide_url_en;
      else if (product.guide_url && !row.guideUrl) row.guideUrl = product.guide_url;
    }

    const cards = [];
    if (intent === 'productgids' && row.ready && product) {
      cards.push(product);
    }

    return {
      text: row.text,
      guideUrl: row.guideUrl,
      guideAnchor: row.guideAnchor,
      cards: cards,
      debug: {
        intent: intent,
        handle: handle,
        verifiedIngredients: verifiedIngredients,
        verifiedNutrition: verifiedNutrition,
      },
    };
  }

  function renderDebugInfo(debug) {
    // Public activation reuses milo_test_mode. Do not expose internal retrieval metadata.
    return '';
  }

  function renderProductCard(product) {
    const img = product.image_url
      ? '<img class="mpic-chat-card__img" src="' +
        escapeHtml(product.image_url) +
        '" alt="" loading="lazy" decoding="async">'
      : '<span class="mpic-chat-card__placeholder" aria-hidden="true">MUSKLE</span>';

    const summary = mpicLocale === 'en' && product.short_summary_en ? product.short_summary_en : product.short_summary;
    const productHref = mpicLocale === 'en' && product.product_url_en ? product.product_url_en : product.product_url;
    const guideHref = mpicLocale === 'en' && product.guide_url_en ? product.guide_url_en : product.guide_url;
    const safety = product.safety_note
      ? '<p class="mpic-chat-card__safety">' + escapeHtml(product.safety_note) + '</p>'
      : '';

    const guideBtn =
      product.guide_available && guideHref
        ? '<a class="mpic-chat-card__btn mpic-chat-card__btn--guide" href="' +
          escapeHtml(guideHref) +
          '">' +
          escapeHtml(UI.readGuide) +
          '</a>'
        : '';

    return (
      '<article class="mpic-chat-card">' +
      '<div class="mpic-chat-card__media">' +
      img +
      '</div>' +
      '<div class="mpic-chat-card__body">' +
      (product.vendor ? '<p class="mpic-chat-card__vendor">' + escapeHtml(product.vendor) + '</p>' : '') +
      '<h3 class="mpic-chat-card__title">' +
      escapeHtml(product.title) +
      '</h3>' +
      (summary ? '<p class="mpic-chat-card__reason">' + escapeHtml(summary) + '</p>' : '') +
      safety +
      '<div class="mpic-chat-card__actions">' +
      (productHref
        ? '<a class="mpic-chat-card__btn mpic-chat-card__btn--product" href="' +
          escapeHtml(productHref) +
          '">' +
          escapeHtml(UI.viewProduct) +
          '</a>'
        : '') +
      guideBtn +
      '</div></div></article>'
    );
  }

  function appendMessage(role, htmlContent, cards, debug) {
    const thread = document.getElementById(THREAD_ID);
    if (!thread) return;

    const row = document.createElement('div');
    row.className = 'mpic-chat-row mpic-chat-row--' + role;

    if (role === 'milo') {
      row.innerHTML =
        '<span class="mpic-chat-row__avatar" aria-hidden="true">' +
        '<img src="' +
        escapeHtml(dialogEl.getAttribute('data-mpic-milo-avatar') || '') +
        '" alt="" width="36" height="36" loading="lazy">' +
        '</span>' +
        '<div class="mpic-chat-row__content">' +
        '<div class="mpic-chat-bubble mpic-chat-bubble--milo">' +
        htmlContent +
        renderDebugInfo(debug) +
        '</div>' +
        (cards && cards.length
          ? '<div class="mpic-chat-cards">' + cards.map(renderProductCard).join('') + '</div>'
          : '') +
        '</div>';
    } else {
      row.innerHTML =
        '<div class="mpic-chat-row__content mpic-chat-row__content--user">' +
        '<div class="mpic-chat-bubble mpic-chat-bubble--user">' +
        escapeHtml(htmlContent) +
        '</div></div>';
    }

    thread.appendChild(row);
    thread.scrollTop = thread.scrollHeight;
  }

  function setComposerBusy(busy) {
    const send = document.getElementById(SEND_ID);
    const composer = document.getElementById(COMPOSER_ID);
    if (composer) {
      if (busy) composer.setAttribute('aria-busy', 'true');
      else composer.removeAttribute('aria-busy');
    }
    if (send) send.disabled = !!busy;
  }

  function appendPendingMilo() {
    const thread = document.getElementById(THREAD_ID);
    if (!thread || pendingRow) return;
    pendingRow = document.createElement('div');
    pendingRow.className = 'mpic-chat-row mpic-chat-row--milo';
    pendingRow.setAttribute('data-mpic-pending', 'true');
    pendingRow.innerHTML =
      '<span class="mpic-chat-row__avatar" aria-hidden="true">' +
      '<img src="' +
      escapeHtml(dialogEl.getAttribute('data-mpic-milo-avatar') || '') +
      '" alt="" width="36" height="36" loading="lazy">' +
      '</span>' +
      '<div class="mpic-chat-row__content">' +
      '<div class="mpic-chat-bubble mpic-chat-bubble--milo">' +
      '<p>' +
      escapeHtml(UI.working) +
      '</p></div></div>';
    thread.appendChild(pendingRow);
    thread.scrollTop = thread.scrollHeight;
  }

  function removePendingMilo() {
    if (pendingRow && pendingRow.parentNode) pendingRow.parentNode.removeChild(pendingRow);
    pendingRow = null;
  }

  function renderLocalResponse(question, response) {
    const intent = pickIntent(question);
    let html = '<p>' + escapeHtml(response.text) + '</p>';
    if (response.guideUrl && intent === 'productgids') {
      html +=
        '<p><a class="mpic-chat-link" href="' +
        escapeHtml(response.guideUrl + (response.guideAnchor || '')) +
        '">' +
        escapeHtml(UI.readGuide) +
        '</a></p>';
    }
    appendMessage('milo', html, response.cards || [], response.debug);
  }

  function askRender(question) {
    const handle = currentHandle;
    if (!handle) {
      return Promise.resolve({
        ok: false,
        source: 'render',
        response: { text: SELECT_PRODUCT_MSG, cards: [] },
      });
    }
    const id = ensureConversation(handle);
    const payload = {
      surface: 'product',
      question: question,
      locale: mpicLocale,
      productHandle: handle,
      conversationId: id,
      history: conversationHistory.slice(),
    };

    return fetch(MILO_ASK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        return res
          .json()
          .catch(function () {
            return null;
          })
          .then(function (body) {
            return { status: res.status, body: body };
          });
      })
      .then(function (result) {
        const body = result && result.body;
        const answerText = body && body.answer && body.answer.text ? normalize(body.answer.text) : '';
        if (!body || body.ok !== true || !answerText) {
          return {
            ok: false,
            source: 'render',
            conversationId: (body && body.conversationId) || id,
            response: { text: UI.temporarilyUnavailable, cards: [] },
          };
        }
        if (body.conversationId) conversationId = String(body.conversationId);
        rememberTurn('user', question);
        rememberTurn('assistant', answerText);
        return {
          ok: true,
          source: 'render',
          conversationId: conversationId,
          handle: handle,
          response: { text: answerText, cards: [] },
        };
      })
      .catch(function () {
        return {
          ok: false,
          source: 'render',
          conversationId: id,
          response: { text: UI.temporarilyUnavailable, cards: [] },
        };
      });
  }

  function askRenderMain(question) {
    const id = ensureConversation('');
    const payload = {
      surface: 'main',
      question: question,
      locale: mpicLocale,
      conversationId: id,
      history: conversationHistory.slice(),
    };

    return fetch(MILO_ASK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        return res
          .json()
          .catch(function () {
            return null;
          })
          .then(function (body) {
            return { status: res.status, body: body };
          });
      })
      .then(function (result) {
        const body = result && result.body;
        const answerText = body && body.answer && body.answer.text ? normalize(body.answer.text) : '';
        if (!body || body.ok !== true || !answerText) {
          return {
            ok: false,
            source: 'render',
            surface: 'main',
            conversationId: (body && body.conversationId) || id,
            response: { text: UI.temporarilyUnavailable, cards: [] },
          };
        }
        if (body.conversationId) conversationId = String(body.conversationId);
        const cards = cardsFromRender(body.cards || []);
        const handles = cards.map(function (card) { return card.handle; }).filter(Boolean);
        rememberTurn('user', question, handles);
        rememberTurn('assistant', answerText, handles);
        return {
          ok: true,
          source: 'render',
          surface: 'main',
          conversationId: conversationId,
          response: { text: answerText, cards: cards },
        };
      })
      .catch(function () {
        return {
          ok: false,
          source: 'render',
          surface: 'main',
          conversationId: id,
          response: { text: UI.temporarilyUnavailable, cards: [] },
        };
      });
  }

  function askMilo(question) {
    const q = normalize(question);
    if (!q) {
      return Promise.resolve({ ok: false, error: 'empty' });
    }
    if (currentTitle && !currentHandle) {
      currentHandle = resolveHandleFromTitle(currentTitle);
    }
    if (isCentralProductAiRoute()) {
      return askRender(q);
    }
    return askRenderMain(q);
  }

  function submitQuestion(question) {
    const normalized = normalize(question);
    if (!normalized || !dialogEl || asking) return;

    appendMessage('user', normalized);
    asking = true;
    const useAi = isCentralProductAiRoute() || isCentralMainAiRoute();
    if (useAi) {
      setComposerBusy(true);
      appendPendingMilo();
    }

    const done = function () {
      asking = false;
      if (useAi) {
        removePendingMilo();
        setComposerBusy(false);
      }
    };

    askMilo(normalized)
      .then(function (result) {
        if (useAi) removePendingMilo();
        if (!result || !result.ok) {
          if (useAi) {
            appendMessage(
              'milo',
              '<p>' + escapeHtml((result && result.response && result.response.text) || UI.temporarilyUnavailable) + '</p>'
            );
            return;
          }
          appendMessage(
            'milo',
            '<p>Testdata kon niet geladen worden. Controleer of de MILO JSON-bestanden in theme assets staan.</p>'
          );
          return;
        }
        if (result.source === 'render') {
          const cards = result.surface === 'main' ? result.response.cards || [] : [];
          appendMessage('milo', '<p>' + escapeHtml(result.response.text) + '</p>', cards);
          return;
        }
        renderLocalResponse(normalized, result.response || {});
      })
      .catch(function () {
        if (useAi) {
          removePendingMilo();
          appendMessage('milo', '<p>' + escapeHtml(UI.temporarilyUnavailable) + '</p>');
        }
      })
      .then(done);
  }

  function productionFooterCopy() {
    return mpicLocale === 'en'
      ? 'Product information — not medical advice.'
      : 'Productinformatie — geen medisch advies.';
  }

  function syncSendState() {
    const input = document.getElementById(INPUT_ID);
    const send = document.getElementById(SEND_ID);
    if (!send) return;
    const hasText = !!(input && normalize(input.value));
    if (hasText) {
      send.classList.add('mpic-popup__send--active');
      send.disabled = false;
      send.removeAttribute('aria-disabled');
      send.tabIndex = 0;
    } else {
      send.classList.remove('mpic-popup__send--active');
      send.disabled = true;
      send.tabIndex = -1;
    }
  }

  function activateProductionComposer() {
    const input = document.getElementById(INPUT_ID);
    const send = document.getElementById(SEND_ID);
    const composer = document.getElementById(COMPOSER_ID);
    const thread = document.getElementById(THREAD_ID);
    const footer = document.querySelector('.mpic-popup__footer-status');

    if (composer) {
      composer.classList.add('mpic-popup__composer--active');
      composer.removeAttribute('aria-disabled');
    }
    if (input) {
      input.disabled = false;
      input.readOnly = false;
      input.removeAttribute('disabled');
      input.removeAttribute('readonly');
      input.removeAttribute('aria-disabled');
      input.tabIndex = 0;
    }
    if (send) {
      send.removeAttribute('aria-disabled');
      send.setAttribute('aria-label', mpicLocale === 'en' ? 'Send' : 'Versturen');
    }
    if (thread) thread.hidden = false;
    if (footer) {
      const text = normalize(footer.textContent);
      if (
        /product-chat wordt voorbereid/i.test(text) ||
        /product chat is being prepared/i.test(text) ||
        /testmodus/i.test(text) ||
        /^test mode\b/i.test(text)
      ) {
        footer.textContent = productionFooterCopy();
      }
    }
    document.querySelectorAll('.mpic-popup__chip').forEach(function (chip) {
      chip.classList.add('mpic-popup__chip--active');
      chip.disabled = false;
      chip.removeAttribute('disabled');
    });
    syncSendState();
  }

  function handleSubmit() {
    const input = document.getElementById(INPUT_ID);
    if (!input || !dialogEl || asking) return;
    const question = normalize(input.value);
    if (!question) return;
    input.value = '';
    syncSendState();
    submitQuestion(question);
  }

  function bindTestMode() {
    if (!dialogEl) return;

    activateProductionComposer();

    const input = document.getElementById(INPUT_ID);
    const send = document.getElementById(SEND_ID);

    if (send) send.addEventListener('click', handleSubmit);
    if (input) {
      input.addEventListener('input', syncSendState);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleSubmit();
        }
      });
    }

    document.querySelectorAll('.mpic-popup__chip--active').forEach(function (chip) {
      chip.addEventListener('click', function () {
        const label = normalize(chip.textContent);
        const mapped = chip.getAttribute('data-mpic-chip-question') || CHIP_QUESTIONS[label];
        if (mapped) submitQuestion(mapped);
      });
    });
  }

  function openDrawer(triggerContext) {
    loadMiloData();
    activateProductionComposer();
    if (testMode) {
      const thread = document.getElementById(THREAD_ID);
      if (thread) thread.innerHTML = '';
    }

    const trigger = triggerContext || {};
    applyProductContext(trigger);

    const dialog = document.getElementById(DIALOG_ID);
    if (dialog && typeof dialog.showDialog === 'function') {
      dialog.showDialog();
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      const trigger = event.target.closest('.mpic-open-drawer');
      if (!trigger) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      openDrawer(readTriggerContext(trigger));
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindTestMode);
  } else {
    bindTestMode();
  }

  window.MuskleMilo = {
    load: loadMiloData,
    setProductContext: function (ctx) {
      ctx = ctx || {};
      const nextHandle = normalize(ctx.handle || '');
      if (nextHandle !== currentHandle) resetConversation();
      currentHandle = nextHandle;
      currentTitle = normalize(ctx.title || '');
      if (Object.prototype.hasOwnProperty.call(ctx, 'productgids')) {
        productgidsFacts = ctx.productgids || null;
      } else if (!currentHandle) {
        productgidsFacts = null;
      }
    },
    getProductContext: function () {
      return { handle: currentHandle, title: currentTitle };
    },
    ask: askMilo,
    available: function () {
      return true;
    },
  };
})();
